// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"283":"4bb6f2dd4a798390","1152":"2c1e69498d1bdb47"}[chunkId] + ".css";
};